import axios from 'axios'

export function fetchProbeTypes(companySlug) {
  return (dispatch, getState) => {
    dispatch({
      type: 'PROBE_TYPES_FETCH',
      payload: axios(`/companies/${companySlug}/probe_types`)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/ProbeTypeActions.js